import { template as template_0924f2e7e8c043b78e1f432277430f8e } from "@ember/template-compiler";
import { hash } from '@ember/helper';
import { modelDisplayName, caption } from 'eflex/helpers';
const JemTaskPushToScheduleDetails = template_0924f2e7e8c043b78e1f432277430f8e(`
<div ...attributes>
  <div class="mt-2 {{@childStatus.taskStatusClass}}">
    {{#each @childStatus.scheduleProcessData as |scheduleDatum|}}
      <div class="schedule-datum">
        <div class="fs-4 fw-semibold text-gray-800">
          {{caption scheduleDatum.station.captions}}
        </div>
        <div class="detail-text-value fw-bold text-gray-900">
          {{scheduleDatum.scheduleTarget}}x {{modelDisplayName scheduleDatum.model}}
        </div>
      </div>
    {{/each}}
  </div>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default template_0924f2e7e8c043b78e1f432277430f8e(`
  {{yield
    (hash
      taskDetails=(component
        JemTaskPushToScheduleDetails
        childStatus=@childStatus
      )
    )
  }}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
